var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 793,
    zoomAndPan: "magnify",
    viewBox: "0 0 594.95996 842.24997",
    height: 1122,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "87eebbccbd"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "a203f87b47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.246094 0 L 594.675781 0 L 594.675781 841.5 L 0.246094 841.5 Z M 0.246094 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c38b00c64d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.246094 0.59375 L 594.675781 0.59375 L 594.675781 840.546875 L 0.246094 840.546875 Z M 0.246094 0.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.0057418,
    gradientTransform: "matrix(0, 839.951537, -623.065086, 0, 608.678865, 0.594561)",
    y1: 0.468039,
    x2: 1.006385,
    gradientUnits: "userSpaceOnUse",
    y2: 0.481082,
    id: "1a81919ada"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.599854%, 8.599854%, 13.299561%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.676147%, 8.657837%, 13.452148%)",
    offset: 0.0121451
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.752441%, 8.71582%, 13.604736%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.804321%, 8.755493%, 13.708496%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.908081%, 8.834839%, 13.917542%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.011841%, 8.914185%, 14.125061%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.115601%, 8.995056%, 14.332581%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.21936%, 9.074402%, 14.5401%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.32312%, 9.153748%, 14.749146%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.428406%, 9.233093%, 14.956665%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.532166%, 9.312439%, 15.164185%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.635925%, 9.391785%, 15.371704%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.739685%, 9.47113%, 15.579224%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.843445%, 9.550476%, 15.788269%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.947205%, 9.629822%, 15.995789%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.050964%, 9.709167%, 16.203308%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.154724%, 9.788513%, 16.410828%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.26001%, 9.869385%, 16.619873%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.36377%, 9.94873%, 16.827393%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.467529%, 10.028076%, 17.034912%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.571289%, 10.107422%, 17.242432%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.675049%, 10.186768%, 17.451477%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.778809%, 10.266113%, 17.658997%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.882568%, 10.345459%, 17.866516%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.986328%, 10.424805%, 18.074036%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.090088%, 10.50415%, 18.281555%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.195374%, 10.583496%, 18.490601%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.299133%, 10.662842%, 18.69812%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.402893%, 10.743713%, 18.90564%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.506653%, 10.823059%, 19.113159%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.610413%, 10.902405%, 19.322205%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.714172%, 10.98175%, 19.529724%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.817932%, 11.061096%, 19.737244%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.921692%, 11.140442%, 19.944763%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.025452%, 11.219788%, 20.153809%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.130737%, 11.299133%, 20.361328%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.234497%, 11.378479%, 20.568848%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.338257%, 11.457825%, 20.776367%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.442017%, 11.53717%, 20.983887%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.545776%, 11.616516%, 21.192932%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.649536%, 11.697388%, 21.400452%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.753296%, 11.776733%, 21.607971%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.857056%, 11.856079%, 21.815491%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.962341%, 11.935425%, 22.024536%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.066101%, 12.014771%, 22.232056%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.169861%, 12.094116%, 22.439575%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.273621%, 12.173462%, 22.647095%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.37738%, 12.252808%, 22.85614%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.48114%, 12.332153%, 23.06366%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.615417%, 12.435913%, 23.332214%)",
    offset: 0.987855
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 12.5%, 23.498535%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "4249da5609"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#87eebbccbd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -59.495996,
    width: 713.951952,
    fill: "#000000",
    y: -84.224997,
    height: 1010.699964,
    fillOpacity: 0.505
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d2a083270b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 0.789062 L 148 0.789062 L 148 95.742188 L 51 95.742188 Z M 51 0.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17db0fbd98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115 15 L 197.449219 15 L 197.449219 95.742188 L 115 95.742188 Z M 115 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c5cf010d91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.582031 15 L 83 15 L 83 95.742188 L 0.582031 95.742188 Z M 0.582031 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "787c03fac9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 198,
    y: 0,
    height: 96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "490cdb0c49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.246094 580.902344 L 594.675781 580.902344 L 594.675781 684.097656 L 0.246094 684.097656 Z M 0.246094 580.902344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a203f87b47)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.246094 0 L 595.214844 0 L 595.214844 841.5 L 0.246094 841.5 Z M 0.246094 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#070560",
    d: "M 0.246094 0 L 595.214844 0 L 595.214844 841.5 L 0.246094 841.5 Z M 0.246094 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c38b00c64d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#1a81919ada)",
    d: "M 594.675781 0.59375 L 0.246094 0.59375 L 0.246094 840.546875 L 594.675781 840.546875 Z M 594.675781 0.59375 ",
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#4249da5609)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 203, 192)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#787c03fac9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d2a083270b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(2.002283, 1.021659, -1.020214, 2.005118, 104.392096, 19.05056)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.729002 18.300523 L 6.445944 13.582731 L 1.728835 8.87356 L 5.300492 5.300384 L -0.000538698 0.000384967 ",
    stroke: "#e8b064",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17db0fbd98)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.352408, -1.797247, 1.794706, -1.354323, 153.28708, 76.386993)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.307453 13.843168 L 4.874037 10.275403 L 1.306965 6.708099 L 4.00646 4.008339 L 0.000612548 -0.000610416 ",
    stroke: "#e8b064",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c5cf010d91)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.352408, -1.797247, 1.794706, 1.354323, 19.55994, 57.667785)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.306615 0.000617954 L 4.874584 3.567338 L 1.307513 7.134642 L 4.007008 9.834402 L 0.000114337 13.841963 ",
    stroke: "#e8b064",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#463d79",
    d: "M 263.054688 393.035156 L 227.675781 496.929688 L 261.960938 483.210938 L 283.75 518.621094 L 318.9375 414.164062 Z M 263.054688 393.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#39306c",
    d: "M 338.984375 394.71875 L 374.363281 498.609375 L 340.078125 484.890625 L 318.292969 520.304688 L 283.101562 415.84375 Z M 338.984375 394.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#28214d",
    d: "M 287.675781 429.324219 L 298.691406 424.105469 L 320.488281 434.796875 L 334.9375 412.921875 L 344.902344 412.121094 L 341.355469 402.46875 L 330.34375 402.46875 L 318.371094 419.820312 L 298.679688 410.695312 L 283.941406 418.539062 Z M 287.675781 429.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e366a",
    d: "M 287.6875 429.246094 L 275.589844 434.925781 L 263.488281 415.441406 L 255.761719 414.480469 L 259.355469 402.621094 L 268.484375 402.621094 L 279.796875 422.484375 L 284.714844 420.023438 Z M 287.6875 429.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2a43",
    d: "M 298.417969 285.214844 L 318.835938 274.738281 L 331.289062 294.03125 L 354.210938 295.183594 L 355.363281 318.140625 L 374.628906 330.609375 L 364.167969 351.054688 L 374.628906 371.503906 L 355.363281 383.972656 L 354.210938 406.925781 L 331.289062 408.078125 L 318.835938 427.375 L 298.417969 416.898438 L 278 427.375 L 265.550781 408.078125 L 242.628906 406.925781 L 241.476562 383.972656 L 222.210938 371.503906 L 232.671875 351.054688 L 222.210938 330.609375 L 241.476562 318.140625 L 242.628906 295.183594 L 265.550781 294.03125 L 278 274.738281 Z M 298.417969 285.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3757",
    d: "M 298.417969 295.492188 L 315.648438 286.652344 L 326.15625 302.9375 L 345.484375 303.910156 L 346.453125 323.261719 L 362.710938 333.785156 L 353.886719 351.03125 L 362.714844 368.285156 L 346.457031 378.808594 L 345.484375 398.164062 L 326.160156 399.136719 L 315.652344 415.417969 L 298.421875 406.578125 L 281.191406 415.417969 L 270.683594 399.136719 L 251.359375 398.164062 L 250.386719 378.808594 L 234.128906 368.285156 L 242.957031 351.03125 L 234.109375 333.796875 L 250.371094 323.273438 L 251.339844 303.917969 L 270.667969 302.945312 L 281.175781 286.664062 Z M 298.417969 295.492188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#211f33",
    d: "M 298.417969 299.582031 L 314.375 291.394531 L 324.109375 306.472656 L 342.023438 307.371094 L 342.921875 325.308594 L 357.976562 335.058594 L 349.800781 351.035156 L 357.976562 367.011719 L 342.921875 376.761719 L 342.023438 394.699219 L 324.109375 395.601562 L 314.375 410.675781 L 298.417969 402.488281 L 282.464844 410.675781 L 272.730469 395.601562 L 254.816406 394.699219 L 253.917969 376.761719 L 238.863281 367.011719 L 247.039062 351.035156 L 238.839844 335.070312 L 253.898438 325.320312 L 254.796875 307.382812 L 272.710938 306.480469 L 282.445312 291.40625 Z M 298.417969 299.582031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8b064",
    d: "M 286.28125 328.035156 L 286.28125 335.378906 L 296.238281 335.378906 L 296.238281 375.1875 L 304.984375 375.1875 L 304.984375 328.035156 Z M 286.28125 328.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8b064",
    d: "M 220.878906 614.394531 L 228.4375 607.195312 C 232.359375 603.507812 233.125 601 233.125 598.25 C 233.125 593.230469 229.164062 590.113281 223.011719 590.113281 C 221.996094 590.058594 220.988281 590.121094 219.988281 590.300781 C 218.984375 590.484375 218.019531 590.777344 217.085938 591.183594 C 216.152344 591.589844 215.28125 592.101562 214.46875 592.710938 C 213.652344 593.324219 212.921875 594.019531 212.269531 594.804688 L 215.949219 597.636719 C 216.753906 596.640625 217.742188 595.882812 218.910156 595.359375 C 220.078125 594.839844 221.300781 594.613281 222.578125 594.679688 C 226.054688 594.679688 227.832031 596.179688 227.832031 598.769531 C 227.832031 600.34375 227.347656 602.007812 224.597656 604.640625 L 213.363281 615.324219 L 213.363281 618.847656 L 234.214844 618.847656 L 234.214844 614.394531 Z M 261.863281 607.957031 L 256.851562 607.957031 L 256.851562 602.25 L 251.921875 602.25 L 251.921875 607.957031 L 242.664062 607.957031 L 255.800781 590.511719 L 250.183594 590.511719 L 236.238281 608.769531 L 236.238281 612.410156 L 251.761719 612.410156 L 251.761719 618.847656 L 256.851562 618.847656 L 256.851562 612.410156 L 261.863281 612.410156 Z M 268.046875 619.128906 C 268.492188 619.132812 268.921875 619.050781 269.332031 618.878906 C 269.742188 618.710938 270.101562 618.46875 270.414062 618.152344 C 270.726562 617.835938 270.964844 617.46875 271.128906 617.058594 C 271.292969 616.644531 271.371094 616.214844 271.363281 615.769531 C 271.378906 615.324219 271.304688 614.890625 271.144531 614.476562 C 270.980469 614.058594 270.746094 613.691406 270.429688 613.371094 C 270.117188 613.054688 269.753906 612.8125 269.339844 612.644531 C 268.925781 612.476562 268.496094 612.398438 268.046875 612.410156 C 267.601562 612.398438 267.171875 612.476562 266.757812 612.644531 C 266.34375 612.8125 265.980469 613.054688 265.667969 613.371094 C 265.351562 613.691406 265.113281 614.058594 264.953125 614.476562 C 264.789062 614.890625 264.71875 615.324219 264.734375 615.769531 C 264.722656 616.214844 264.800781 616.644531 264.964844 617.058594 C 265.132812 617.46875 265.371094 617.835938 265.683594 618.152344 C 265.992188 618.46875 266.355469 618.710938 266.765625 618.878906 C 267.175781 619.050781 267.605469 619.132812 268.046875 619.128906 Z M 286.074219 619.25 C 292.816406 619.25 297.917969 613.988281 297.917969 604.679688 C 297.917969 595.371094 292.824219 590.109375 286.074219 590.109375 C 279.367188 590.109375 274.273438 595.371094 274.273438 604.679688 C 274.273438 613.988281 279.367188 619.25 286.074219 619.25 Z M 286.074219 614.679688 C 282.234375 614.679688 279.558594 611.527344 279.558594 604.679688 C 279.558594 597.832031 282.226562 594.679688 286.074219 594.679688 C 289.957031 594.679688 292.625 597.832031 292.625 604.679688 C 292.625 611.527344 289.953125 614.679688 286.074219 614.679688 Z M 313.265625 619.25 C 320.007812 619.25 325.109375 613.988281 325.109375 604.679688 C 325.109375 595.371094 320.015625 590.109375 313.265625 590.109375 C 306.554688 590.109375 301.464844 595.371094 301.464844 604.679688 C 301.464844 613.988281 306.566406 619.25 313.277344 619.25 Z M 313.265625 614.679688 C 309.425781 614.679688 306.75 611.527344 306.75 604.679688 C 306.75 597.832031 309.417969 594.679688 313.265625 594.679688 C 317.148438 594.679688 319.816406 597.832031 319.816406 604.679688 C 319.816406 611.527344 317.15625 614.679688 313.277344 614.679688 Z M 340.457031 619.25 C 347.199219 619.25 352.300781 613.988281 352.300781 604.679688 C 352.300781 595.371094 347.207031 590.109375 340.457031 590.109375 C 333.746094 590.109375 328.65625 595.371094 328.65625 604.679688 C 328.65625 613.988281 333.769531 619.25 340.476562 619.25 Z M 340.457031 614.679688 C 336.617188 614.679688 333.941406 611.527344 333.941406 604.679688 C 333.941406 597.832031 336.609375 594.679688 340.457031 594.679688 C 344.339844 594.679688 347.007812 597.832031 347.007812 604.679688 C 347.007812 611.527344 344.359375 614.679688 340.476562 614.679688 Z M 382.007812 604.480469 L 376.796875 604.480469 C 376.796875 610.753906 373.398438 614.4375 366.457031 614.4375 L 364.722656 614.4375 L 364.722656 605.855469 L 375.027344 600.394531 L 375.027344 597.4375 L 364.722656 602.863281 L 364.722656 600.070312 L 375.027344 594.644531 L 375.027344 591.648438 L 364.722656 597.113281 L 364.722656 590.511719 L 359.550781 590.511719 L 359.550781 599.824219 L 355.308594 602.089844 L 355.308594 605.050781 L 359.550781 602.824219 L 359.550781 605.617188 L 355.308594 607.84375 L 355.308594 610.839844 L 359.550781 608.574219 L 359.550781 618.847656 L 365.332031 618.847656 C 376.410156 618.847656 382.070312 613.421875 382.03125 604.476562 Z M 382.007812 604.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#490cdb0c49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#171723",
    d: "M -13.816406 580.9375 L 608.984375 580.9375 C 608.984375 615.523438 608.984375 650.113281 608.984375 684.699219 C 401.386719 684.699219 193.785156 684.699219 -13.816406 684.699219 C -13.816406 650.113281 -13.816406 615.523438 -13.816406 580.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8b064",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.732096, 656.604531)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.125 -27.75 C 25.207031 -27.46875 29.078125 -26.085938 31.734375 -23.609375 C 34.398438 -21.140625 35.734375 -17.914062 35.734375 -13.9375 C 35.734375 -11.164062 35.0625 -8.703125 33.71875 -6.546875 C 32.375 -4.398438 30.382812 -2.703125 27.75 -1.453125 C 25.113281 -0.203125 21.898438 0.421875 18.109375 0.421875 C 14.585938 0.421875 11.265625 -0.144531 8.140625 -1.28125 C 5.023438 -2.414062 2.519531 -3.929688 0.625 -5.828125 L 3.046875 -9.78125 C 4.671875 -8.113281 6.820312 -6.757812 9.5 -5.71875 C 12.1875 -4.675781 15.054688 -4.15625 18.109375 -4.15625 C 22.085938 -4.15625 25.160156 -5.019531 27.328125 -6.75 C 29.503906 -8.488281 30.59375 -10.882812 30.59375 -13.9375 C 30.59375 -16.945312 29.503906 -19.304688 27.328125 -21.015625 C 25.160156 -22.734375 21.878906 -23.59375 17.484375 -23.59375 L 14.015625 -23.59375 L 14.015625 -27.265625 L 27.46875 -44.125 L 2.640625 -44.125 L 2.640625 -48.5625 L 33.859375 -48.5625 L 33.859375 -45.03125 Z M 20.125 -27.75 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8b064",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.85387, 656.604531)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.96875 0.421875 C 19.21875 0.421875 15.875 -0.570312 12.9375 -2.5625 C 10 -4.550781 7.707031 -7.40625 6.0625 -11.125 C 4.425781 -14.851562 3.609375 -19.238281 3.609375 -24.28125 C 3.609375 -29.320312 4.425781 -33.703125 6.0625 -37.421875 C 7.707031 -41.148438 10 -44.007812 12.9375 -46 C 15.875 -47.988281 19.21875 -48.984375 22.96875 -48.984375 C 26.707031 -48.984375 30.046875 -47.988281 32.984375 -46 C 35.921875 -44.007812 38.222656 -41.148438 39.890625 -37.421875 C 41.554688 -33.703125 42.390625 -29.320312 42.390625 -24.28125 C 42.390625 -19.238281 41.554688 -14.851562 39.890625 -11.125 C 38.222656 -7.40625 35.921875 -4.550781 32.984375 -2.5625 C 30.046875 -0.570312 26.707031 0.421875 22.96875 0.421875 Z M 22.96875 -4.15625 C 25.78125 -4.15625 28.257812 -4.941406 30.40625 -6.515625 C 32.5625 -8.085938 34.238281 -10.378906 35.4375 -13.390625 C 36.644531 -16.398438 37.25 -20.03125 37.25 -24.28125 C 37.25 -28.53125 36.644531 -32.160156 35.4375 -35.171875 C 34.238281 -38.179688 32.5625 -40.472656 30.40625 -42.046875 C 28.257812 -43.617188 25.78125 -44.40625 22.96875 -44.40625 C 20.144531 -44.40625 17.65625 -43.617188 15.5 -42.046875 C 13.351562 -40.472656 11.675781 -38.179688 10.46875 -35.171875 C 9.269531 -32.160156 8.671875 -28.53125 8.671875 -24.28125 C 8.671875 -20.03125 9.269531 -16.398438 10.46875 -13.390625 C 11.675781 -10.378906 13.351562 -8.085938 15.5 -6.515625 C 17.65625 -4.941406 20.144531 -4.15625 22.96875 -4.15625 Z M 22.96875 -4.15625 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8b064",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(239.773416, 656.604531)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.359375 0.34375 C 6.335938 0.34375 5.46875 -0.0234375 4.75 -0.765625 C 4.03125 -1.503906 3.671875 -2.40625 3.671875 -3.46875 C 3.671875 -4.53125 4.03125 -5.421875 4.75 -6.140625 C 5.46875 -6.859375 6.335938 -7.21875 7.359375 -7.21875 C 8.367188 -7.21875 9.242188 -6.859375 9.984375 -6.140625 C 10.722656 -5.421875 11.09375 -4.53125 11.09375 -3.46875 C 11.09375 -2.40625 10.722656 -1.503906 9.984375 -0.765625 C 9.242188 -0.0234375 8.367188 0.34375 7.359375 0.34375 Z M 7.359375 0.34375 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8b064",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.478756, 656.604531)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.96875 0.421875 C 19.21875 0.421875 15.875 -0.570312 12.9375 -2.5625 C 10 -4.550781 7.707031 -7.40625 6.0625 -11.125 C 4.425781 -14.851562 3.609375 -19.238281 3.609375 -24.28125 C 3.609375 -29.320312 4.425781 -33.703125 6.0625 -37.421875 C 7.707031 -41.148438 10 -44.007812 12.9375 -46 C 15.875 -47.988281 19.21875 -48.984375 22.96875 -48.984375 C 26.707031 -48.984375 30.046875 -47.988281 32.984375 -46 C 35.921875 -44.007812 38.222656 -41.148438 39.890625 -37.421875 C 41.554688 -33.703125 42.390625 -29.320312 42.390625 -24.28125 C 42.390625 -19.238281 41.554688 -14.851562 39.890625 -11.125 C 38.222656 -7.40625 35.921875 -4.550781 32.984375 -2.5625 C 30.046875 -0.570312 26.707031 0.421875 22.96875 0.421875 Z M 22.96875 -4.15625 C 25.78125 -4.15625 28.257812 -4.941406 30.40625 -6.515625 C 32.5625 -8.085938 34.238281 -10.378906 35.4375 -13.390625 C 36.644531 -16.398438 37.25 -20.03125 37.25 -24.28125 C 37.25 -28.53125 36.644531 -32.160156 35.4375 -35.171875 C 34.238281 -38.179688 32.5625 -40.472656 30.40625 -42.046875 C 28.257812 -43.617188 25.78125 -44.40625 22.96875 -44.40625 C 20.144531 -44.40625 17.65625 -43.617188 15.5 -42.046875 C 13.351562 -40.472656 11.675781 -38.179688 10.46875 -35.171875 C 9.269531 -32.160156 8.671875 -28.53125 8.671875 -24.28125 C 8.671875 -20.03125 9.269531 -16.398438 10.46875 -13.390625 C 11.675781 -10.378906 13.351562 -8.085938 15.5 -6.515625 C 17.65625 -4.941406 20.144531 -4.15625 22.96875 -4.15625 Z M 22.96875 -4.15625 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8b064",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.398302, 656.604531)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.96875 0.421875 C 19.21875 0.421875 15.875 -0.570312 12.9375 -2.5625 C 10 -4.550781 7.707031 -7.40625 6.0625 -11.125 C 4.425781 -14.851562 3.609375 -19.238281 3.609375 -24.28125 C 3.609375 -29.320312 4.425781 -33.703125 6.0625 -37.421875 C 7.707031 -41.148438 10 -44.007812 12.9375 -46 C 15.875 -47.988281 19.21875 -48.984375 22.96875 -48.984375 C 26.707031 -48.984375 30.046875 -47.988281 32.984375 -46 C 35.921875 -44.007812 38.222656 -41.148438 39.890625 -37.421875 C 41.554688 -33.703125 42.390625 -29.320312 42.390625 -24.28125 C 42.390625 -19.238281 41.554688 -14.851562 39.890625 -11.125 C 38.222656 -7.40625 35.921875 -4.550781 32.984375 -2.5625 C 30.046875 -0.570312 26.707031 0.421875 22.96875 0.421875 Z M 22.96875 -4.15625 C 25.78125 -4.15625 28.257812 -4.941406 30.40625 -6.515625 C 32.5625 -8.085938 34.238281 -10.378906 35.4375 -13.390625 C 36.644531 -16.398438 37.25 -20.03125 37.25 -24.28125 C 37.25 -28.53125 36.644531 -32.160156 35.4375 -35.171875 C 34.238281 -38.179688 32.5625 -40.472656 30.40625 -42.046875 C 28.257812 -43.617188 25.78125 -44.40625 22.96875 -44.40625 C 20.144531 -44.40625 17.65625 -43.617188 15.5 -42.046875 C 13.351562 -40.472656 11.675781 -38.179688 10.46875 -35.171875 C 9.269531 -32.160156 8.671875 -28.53125 8.671875 -24.28125 C 8.671875 -20.03125 9.269531 -16.398438 10.46875 -13.390625 C 11.675781 -10.378906 13.351562 -8.085938 15.5 -6.515625 C 17.65625 -4.941406 20.144531 -4.15625 22.96875 -4.15625 Z M 22.96875 -4.15625 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8b064",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.317849, 656.604531)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.96875 0.421875 C 19.21875 0.421875 15.875 -0.570312 12.9375 -2.5625 C 10 -4.550781 7.707031 -7.40625 6.0625 -11.125 C 4.425781 -14.851562 3.609375 -19.238281 3.609375 -24.28125 C 3.609375 -29.320312 4.425781 -33.703125 6.0625 -37.421875 C 7.707031 -41.148438 10 -44.007812 12.9375 -46 C 15.875 -47.988281 19.21875 -48.984375 22.96875 -48.984375 C 26.707031 -48.984375 30.046875 -47.988281 32.984375 -46 C 35.921875 -44.007812 38.222656 -41.148438 39.890625 -37.421875 C 41.554688 -33.703125 42.390625 -29.320312 42.390625 -24.28125 C 42.390625 -19.238281 41.554688 -14.851562 39.890625 -11.125 C 38.222656 -7.40625 35.921875 -4.550781 32.984375 -2.5625 C 30.046875 -0.570312 26.707031 0.421875 22.96875 0.421875 Z M 22.96875 -4.15625 C 25.78125 -4.15625 28.257812 -4.941406 30.40625 -6.515625 C 32.5625 -8.085938 34.238281 -10.378906 35.4375 -13.390625 C 36.644531 -16.398438 37.25 -20.03125 37.25 -24.28125 C 37.25 -28.53125 36.644531 -32.160156 35.4375 -35.171875 C 34.238281 -38.179688 32.5625 -40.472656 30.40625 -42.046875 C 28.257812 -43.617188 25.78125 -44.40625 22.96875 -44.40625 C 20.144531 -44.40625 17.65625 -43.617188 15.5 -42.046875 C 13.351562 -40.472656 11.675781 -38.179688 10.46875 -35.171875 C 9.269531 -32.160156 8.671875 -28.53125 8.671875 -24.28125 C 8.671875 -20.03125 9.269531 -16.398438 10.46875 -13.390625 C 11.675781 -10.378906 13.351562 -8.085938 15.5 -6.515625 C 17.65625 -4.941406 20.144531 -4.15625 22.96875 -4.15625 Z M 22.96875 -4.15625 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8b064",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(392.237395, 656.604531)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 45.15625 -24.421875 C 45.15625 -16.648438 42.832031 -10.632812 38.1875 -6.375 C 33.539062 -2.125 26.734375 0 17.765625 0 L 9.921875 0 L 9.921875 -19.140625 L 2.078125 -15.046875 L 2.078125 -18.3125 L 9.921875 -22.40625 L 9.921875 -28.921875 L 2.078125 -24.84375 L 2.078125 -28.09375 L 9.921875 -32.1875 L 9.921875 -48.5625 L 14.921875 -48.5625 L 14.921875 -34.828125 L 34.203125 -44.953125 L 34.203125 -41.6875 L 14.921875 -31.5625 L 14.921875 -25.046875 L 34.203125 -35.171875 L 34.203125 -31.90625 L 14.921875 -21.78125 L 14.921875 -4.4375 L 18.734375 -4.4375 C 25.765625 -4.4375 31.082031 -6.160156 34.6875 -9.609375 C 38.289062 -13.054688 40.09375 -17.992188 40.09375 -24.421875 Z M 45.15625 -24.421875 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6ec1749a4f01137585d489350f49da45.svg";
export { ForwardRef as ReactComponent };